import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "./Incorporation.scss";
import Image from "react-bootstrap/Image";
import incorporationImg from "../../assets/images/incorporation-service.jpg";

import { useTranslation } from "react-i18next";

const IncorporationService = () => {
  const { t } = useTranslation(["common","incorporation"]);

  return (
    <div className="MainbBody IncorporationService">
      <div className="PricelistBanner MapBanner">
        <Container>
          <Row>
            <Col sm={8}>
              <h3>{t('incorporation:title')}</h3>
            </Col>
          </Row>
        </Container>
      </div>
      <div className="PricelistBody">
        <Container>
          <div className="LocationGrid">
            <Row>
              <Col sm={12} md={6}>
                <div className="image">
                  <Image src={incorporationImg} alt="BoxImg" />
                </div>
              </Col>
              <Col sm={12} md={6}>
                <div className="description">
                  <p><strong>{t('incorporation:text_0.title')}</strong></p>
                  <p>{t('incorporation:text_0.text')}</p>
                </div>
              </Col>
            </Row>
          </div>

          <div className="LocationGrid">
            <Row>
              <Col sm={12}>
                <div className="description">
                  <p><strong>{t('incorporation:text_1.title')}</strong></p>
                  <p>{t('incorporation:text_1.text')}</p>
                </div>
              </Col>
            </Row>
          </div>
          
          <div className="LocationGrid">
            <Row>
              <Col sm={12}>
                <div className="description">
                  <p><strong>{t('incorporation:text_2.title')}</strong></p>
                  <p>{t('incorporation:text_2.text')}</p>
                </div>
              </Col>
            </Row>
          </div>
          
          <div className="LocationGrid">
            <Row>
              <Col sm={12} md={6}>
                <div className="description">
                  <p><strong>{t('incorporation:text_3.title')}</strong></p>
                  <p>{t('incorporation:text_3.text')}</p>
                </div>
              </Col>
              <Col sm={12} md={6}>
                <div className="image">
                  <Image src={incorporationImg} alt="BoxImg" />
                </div>
              </Col>
            </Row>
          </div>
          
          <div className="LocationGrid">
            <Row>
              <Col sm={12}>
                <div className="description">
                  <p><strong>{t('incorporation:text_4.title')}</strong></p>
                  <p>{t('incorporation:text_4.text')}</p>
                </div>
              </Col>
            </Row>
          </div>
          
          <div className="LocationGrid">
            <Row>
              <Col sm={12}>
                <div className="description">
                  <p><strong>{t('incorporation:text_5.title')}</strong></p>
                  <p>{t('incorporation:text_5.text')}</p>
                </div>
              </Col>
            </Row>
          </div>
          
          <div className="LocationGrid">
            <Row>
              <Col sm={12}>
                <div className="description">
                  <p><strong>{t('incorporation:text_6.title')}</strong></p>
                  <p>{t('incorporation:text_6.text')}</p>
                </div>
              </Col>
            </Row>
          </div>
          
          <div className="LocationGrid">
            <Row>
              <Col sm={12} md={6}>
                <div className="image">
                  <Image src={incorporationImg} alt="BoxImg" />
                </div>
              </Col>
              <Col sm={12} md={6}>
                <div className="description">
                  <p><strong>{t('incorporation:text_7.title')}</strong></p>
                  <p>{t('incorporation:text_7.text')}</p>
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    </div>
  );
};

export default IncorporationService;
